export default __webpack_public_path__ + "static/media/christmas_corner_top.716e1283.png";